module.exports = __webpack_public_path__ + "images/application/b-close-f16a5949.png";